import { FC, useState, useEffect } from "react";
import { Button, Search } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import {
	editObjectConnection,
	getObjectConnection,
} from "toolkit/steps/stepTwo/objectsRegister/objectsRegister.thunks";
import { ClearObjectConnection } from "toolkit/steps/stepTwo/objectsRegister/objectsRegister.slice";
import { useParams } from "react-router-dom";
import { ClearProcessConnection } from "toolkit/steps/stepTwo/stepTwo.slice";
import { editProcessConnection, getProcessConnection } from "toolkit/steps/stepTwo/stepTwo.thunks";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import styles from "./SettingConnection.module.sass";

interface SettingConnectionProps {
	mode: "process" | "object";
	close: () => void;
	targetId: number;
	title: string;
	subtitle: string;
}

export const SettingConnection: FC<SettingConnectionProps> = ({ mode, close, targetId, title, subtitle }) => {
	const dispatch = useAppDispatch();
	const objectConnection = useAppSelector((state) => state.objectsRegister.objectConnection);
	const processConnection = useAppSelector((state) => state.stepTwo.processConnection);
	const [connection, setConnection] = useState<any[]>([]);
	const [newConnection, setNewConnection] = useState<any[]>([]);
	const creatorId = useAppSelector((state) => state.profile.profile.id);
	const [search, setSearch] = useState<string>("");
	const [loading, setLoading] = useState<boolean>(true);
	const { organizationId } = useParams();

	const [allChecked, setAllChecked] = useState<boolean|null>(false);

	useEffect(() => {
		if (!organizationId) return;
		if (mode === "object") {
			dispatch(ClearObjectConnection());
			dispatch(getObjectConnection({ organizationId: +organizationId, objectId: targetId, setLoading }));
		} else {
			dispatch(ClearProcessConnection());
			dispatch(getProcessConnection({ organizationId: +organizationId, processId: targetId, setLoading }));
		}
		//eslint-disable-next-line
	}, [targetId]);

	useEffect(() => {
		const localConnection: any[] = mode === "object" ? objectConnection : processConnection;
		setNewConnection([...localConnection]);
		setConnection([...localConnection]);
		//eslint-disable-next-line
	}, [targetId, objectConnection, processConnection]);

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		if (!organizationId) return;
		if (loading) {
			close();
			return;
		}
		if (mode === "object") {
			dispatch(
				editObjectConnection({
					organizationId: +organizationId,
					objectId: targetId,
					all:allChecked,
					connection: newConnection,
				}),
			);
		} else {
			dispatch(
				editProcessConnection({
					organizationId: +organizationId,
					processId: targetId,
					all:allChecked,
					connection: newConnection,
				}),
			);
		}
		close();
	};

	const checkboxHandler = (e: any, item: any) => {
		let newConnection2: any[] = [...newConnection];
		let connectionIndex: number =
			mode === "object"
				? objectConnection.findIndex((connection) => connection.id === item.id)
				: processConnection.findIndex((connection) => connection.id === item.id);
		newConnection2[connectionIndex] = { ...newConnection[connectionIndex], linkExists: e.target.checked };
		setNewConnection(newConnection2);
	};

	useEffect(() => {
		if (newConnection) {
			const all = newConnection.every(_ => _.linkExists);
			const some = newConnection.some(_ => _.linkExists);
			if (!all) {
				if (some) {
					setAllChecked(null);
				}else{
					setAllChecked(all);
				}
			}else{
				setAllChecked(all);
			}
		}
	}, [newConnection]);

	return (
		<section className={styles.wrp}>
			<h4 className={styles.title}>{title}</h4>
			<span className={styles.subtitle}>{subtitle}</span>
			<form onSubmit={submitHandler}>
				<div className={styles["form-wrp"]}>
					<Search value={search} onChange={(e) => setSearch(e.target.value)} />
					<ul className={styles.list}>
						<li className={styles["list-item"]}>
							<label title={'Ввыбрать всё'} htmlFor={`connection-0`} className={styles["list-item-label"]}>
								<input
									onChange={(e) => {
										setNewConnection(prevState => prevState.map(_ => ({..._, linkExists: !allChecked})))
									}}
									// value={allChecked}
									// defaultChecked={allChecked}
									checked={!!allChecked}
									type="checkbox"
									id={`connection-0`}
									className={styles["list-item-checkbox"]}
								/>
								<div className={styles["list-item-wrp"]}>
									<span className={styles["list-item-txt"]}>Выбрать всё</span>
								</div>
							</label>
						</li>
						{loading && (
							<div className="loading-wrp">
								<LoadingIcon className="loading-icon" />
							</div>
						)}
						{(search.trim()
							? newConnection.filter(
									(item) =>
										item.sequence.toLowerCase().includes(search.trim().toLowerCase()) ||
										item.name.toLowerCase().includes(search.trim().toLowerCase()),
							  )
							: newConnection
						).map((item: any) => (
							<li className={styles["list-item"]} key={item.id}>
								<label title={item.name} htmlFor={`connection-${item.id}`} className={styles["list-item-label"]}>
									<input
										onChange={(e) => checkboxHandler(e, item)}
										checked={allChecked||item.linkExists}
										defaultChecked={item.linkExists}
										type="checkbox"
										id={`connection-${item.id}`}
										className={styles["list-item-checkbox"]}
									/>
									<div className={styles["list-item-wrp"]}>
										<span className={styles["list-item-txt"]}>{item.sequence}</span>
										<span className={styles["list-item-txt"]}>{item.name}</span>
									</div>
								</label>
							</li>
						))}
					</ul>
				</div>
				<div className={styles.btns}>
					<Button className={styles.button} onClick={close} type="button" variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button className={styles.button} type="submit">
						Готово
					</Button>
				</div>
			</form>
		</section>
	);
};
